import * as yup from "yup";

export const scheduleSchema = yup.object().shape({
  scheduleDays: yup
    .array(
      yup
        .number()
        .label("Day")
        .min(1)
        .max(7)
        .required()
    )
    .label("Days")
    .required(),
  monthlyFrequency: yup
    .number()
    .oneOf([
      1,
      2,
      3,
      4
    ])
    .label("Frequency")
    .required(),
  startDate: yup
    .date()
    .label("Start date")
    .required(),
  endDate: yup
    .date()
    .label("End date")
    .when("startDate", (startDate: Date, schema: yup.DateSchema) => {
      if (startDate) {
        return schema.min(startDate);
      } else {
        return schema;
      }
    })
});
